import styled from 'styled-components';

export const RuleGroupSection = styled.div`
  display: flex;
  align-items: start;
  gap: 8px;
  padding: 8px 0;
`;

export const RuleGroupContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: start;
  background: #FBFBFB;
  border: 1px dotted #B7B7B7;
  border-radius: 8px;
  width: 100%;

  .ruleGroup .ruleGroup-body .rule {
    background-color: #FBFBFB !important;
  }
`;